import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_RAFFLES, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_RAFFLE, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.store(obj).then(res => {
    commit(types.SET_RAFFLE, res.data.data)
    return res
  })
}

export const deleteRaffle = async ({ commit }, obj) => {
  await services.deleteRaffle(obj).then(res => {
    return res
  })
}
